export const engineerBindingListOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: false,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: "200",
    labelWidth: "150",
    defaultSort: {
      prop: "createTime",
      order: "descending",
    },
    column: [
      {
        label: "工程师名称",
        prop: "name",
        type: "input",
        search: true,
        span: 13,
      }
    ],
  };
  